<template>
    <paper class="payment-duration-detail">
        <el-card>
            <div class="remark-wrapper">
                <div class="remark-title">司机收款时长说明</div>
                <div class="remark">
                    1、司机收款时长定义，即从发车单抵达日期开始，供应商应在司机收款时长配置的天数时间内，向司机完成运费支付。
                </div>
                <div class="remark">
                    2、供应商可自行配置司机收款时长，发车单符合配置明细项条件的，则取配置的天数计算司机应收款日期；如发车单不符合配置条件，则取默认值60天。
                </div>
            </div>
            <div class="btn-wrapper">
                <el-button type="info" @click="handleCancel">关闭</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存并提交审批</el-button>
            </div>
        </el-card>
        <div class="content-wrapper">
            <div class="title">司机收款时长配置</div>
            <el-form :model="formData" :rules="rules" ref="formRef">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item
                            label="供应商编码："
                            label-width="110px"
                            prop="carrierCode"
                        >
                            <el-input
                                v-model="formData.carrierCode"
                                disabled
                            ></el-input>
                            <!-- <advance-dialog
                                v-model="formData.carrierCode"
                                :mValue="formData.carrierCode"
                                :params="carrierConfig"
                                @getAdvanceValue="getCarrierCode"
                                :disabled="isEdit"
                            >
                            </advance-dialog> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="供应商名称：" label-width="110px" prop="carrierName">
                            <el-input
                                v-model="formData.carrierName"
                                disabled
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item
                            label="配置维度："
                            label-width="110px"
                            prop="configType"
                        >
                            <otpSelect
                                :optionNum="'CONFIG_TYPE'"
                                @getSelectValue="getConfigType"
                                :mValue="formData.configType"
                                placeholder="请选择"
                                :prop="'configType'"
                                :disabled="isEdit"
                            >
                            </otpSelect>
                            <span
                                class="tooltip"
                                v-if="+formData.configType === 10"
                                >配置明细必须选择供应商主合同进行收款时长配置</span
                            >
                            <span
                                class="tooltip"
                                v-if="+formData.configType === 20"
                                >配置明细必须选择供应商下的司机进行收款时长配置</span
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="司机收款时长："
                            label-width="110px"
                            prop="paymentType"
                        >
                            <otpSelect
                                :optionNum="'PAYMENT_TYPE'"
                                @getSelectValue="getPaymentType"
                                :mValue="formData.paymentType"
                                placeholder="请选择"
                                :prop="'paymentType'"
                            >
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item prop="uniteDay" v-if="+formData.paymentType === 10">
                            <otpSelect
                                :optionNum="'UNITE_DAY'"
                                @getSelectValue="getUniteDay"
                                :mValue="formData.uniteDay"
                                placeholder="请选择收款时长天数"
                                :prop="'uniteDay'"
                            >
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item
                        label="配置维度明细："
                        label-width="110px"
                        prop="detailConfig"
                    >
                        <el-button
                            type="primary"
                            :disabled="
                                !formData.configType || !formData.carrierCode
                            "
                            @click="openAdvanceDialog"
                            >明细选择</el-button
                        >
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="table-wrapper">
                <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" style="width: 100%;">
                    <el-table-column
                        prop="detailConfigurationName"
                        label="配置维度明细项"
                        min-width="250"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="detailConfigurationDay"
                        label="司机收款时长（天）"
                        min-width="200"
                    >
                        <template slot-scope="scope">
                             <otpSelect
                                v-if="+formData.paymentType === 20"
                                :optionNum="'UNITE_DAY'"
                                @getSelectValue="getDetailConfigurationDay($event, scope.row, 'detailConfigurationDay')"
                                :mValue="scope.row.detailConfigurationDay"
                                placeholder="收款时长天数"
                                :prop="'detailConfigurationDay'"
                            >
                             </otpSelect>
                            <div class="notEdit" v-else>
                                {{ scope.row.detailConfigurationDay }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button
                                @click="
                                    handleDelete(scope.$index, scope.row)
                                "
                                type="text"
                                size="small"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <contract-or-driver-dialog
            ref="contractOrDriverDialog"
            v-model="formData.carrierCode"
            :mValue="formData.carrierCode"
            :params="contractConfig"
            :formData="formData"
            :disabledEdit="true"
            @confirm="confirm"
        >
        </contract-or-driver-dialog>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import otpSelect from '@/components/lots/otpSelect';
import advanceDialog from '@/components/lots/otpAdvance';
import contractOrDriverDialog from './contractOrDriverDialog';
import { carrierConfig, contractConfig, driverConfig } from './config';
import { mergeAndDistinctByProperty, validatedTableData } from './util.js';
import { updateDetail, checkInfo, confirmSubmission } from '../../../../../api/driverPaymentDurationConfig.js';
import { mapState } from 'vuex';
export default {
    name: 'PaymentDurationDetail',
    components: { paper, otpSelect, advanceDialog, contractOrDriverDialog },
    data () {
        return {
            carrierConfig,
            contractConfig,
            driverConfig,
            formData: {
                carrierCode: '',
                carrierName: '',
                configType: '',
                paymentType: '',
                uniteDay: '',
                configId: '',
                detailConfig: ''
            },
            rules: {
                carrierCode: [{ required: true, message: '请选择供应商', trigger: ['change', 'blur'] }],
                carrierName: [{ required: true, message: '请选择供应商', trigger: ['change', 'blur'] }],
                configType: [{ required: true, message: '请选择配置维度', trigger: ['change', 'blur'] }],
                paymentType: [{ required: true, message: '请选择司机收款时长设置', trigger: ['change', 'blur'] }],
                uniteDay: [{ required: true, message: '请选择收款时长天数', trigger: ['change', 'blur'] }],
                detailConfig: [{ required: true, validator: this.validateDetailConfig, trigger: ['change', 'blur'] }]
            },
            tableData: [],
            loading: false,
            submitLoading: false,
            tableHeight: 0,
            configId: ''
        };
    },
    computed: {
        isEdit () {
            return this.$route.query.type === 'edit';
        },
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier
        })
    },
    async mounted () {
        this.initTableHeight();
        window.addEventListener('resize', this.initTableHeight);
        if (this.$route.query.id) {
            this.configId = this.$route.query.id;
            await this.init();
        } else {
            this.$refs.formRef.resetFields();
            this.tableData = [];
        }
        this.formData.carrierCode = this.supplier.supplierCode;
        this.formData.carrierName = this.supplier.supplierNameCn;
    },
    async activated () {
        this.initTableHeight();
        if (this.$route.query.id) {
            this.configId = this.$route.query.id;
            await this.init();
        } else {
            this.$refs.formRef.resetFields();
            this.tableData = [];
        }
        this.formData.carrierCode = this.supplier.supplierCode;
        this.formData.carrierName = this.supplier.supplierNameCn;
    },
    methods: {
        initTableHeight () {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - 380;
            });
        },
        init () {
            this.loading = true;
            updateDetail({ id: this.configId }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list || [];
                    Object.keys(this.formData).forEach(key => {
                        this.formData[key] = res.data[key] || '';
                    });
                }
            })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 选择供应商编码回调
        getCarrierCode (data) {
            if (this.formData.carrierCode && data.carrierCode !== this.formData.carrierCode) {
                this.tableData = [];
            }
            this.formData.carrierCode = data.carrierCode || '';
            this.formData.carrierName = data.carrierName || '';
        },
        // 选择配置维度回调
        getConfigType (data) {
            if (data.configType !== this.formData.configType) {
                this.tableData = [];
            }
            this.formData.configType = data.configType || '';
        },
        // 选择收款时长设置方式回调
        getPaymentType (data) {
            if (data.paymentType !== this.formData.paymentType) {
                this.formData.uniteDay = '';
                this.tableData.forEach(item => {
                    this.$set(item, 'detailConfigurationDay', this.formData.uniteDay);
                });
            }
            this.formData.paymentType = data.paymentType || '';
        },
        // 统一设置收款时长回调
        getUniteDay (data) {
            this.formData.uniteDay = data.uniteDay;
            this.tableData.forEach(item => {
                this.$set(item, 'detailConfigurationDay', data.uniteDay);
            });
        },
        // 配置明细收款时长回调
        getDetailConfigurationDay (data, row, prop) {
            row[prop] = data.detailConfigurationDay;
        },
        validateDetailConfig (rule, value, callback) {
            if (!this.tableData.length) {
                callback(new Error('请进行明细选择'));
            }
            callback();
        },
        // 打开高级弹窗
        openAdvanceDialog () {
            if (+this.formData.configType === 10) {
                this.$refs.contractOrDriverDialog.show(true, this.contractConfig, { supplierCode: this.formData.carrierCode, applyType: 1, contractStatus: 60 }, '', [], this.formData.carrierCode);
            } else {
                this.$refs.contractOrDriverDialog.show(true, this.driverConfig, { supplierCode: this.formData.carrierCode, enableFlag: 0 }, '', [], this.formData.carrierCode);
            }
        },
        confirm (data) {
            const codes = data.codes ? data.codes.split(',') : [];
            const names = data.names ? data.names.split(',') : [];
            const selectedData = codes.map((code, index) => {
                return {
                    detailConfigurationCode: code || '',
                    detailConfigurationName: `${code || ''} - ${names[index] || ''}`,
                    detailConfigurationDay: this.formData.uniteDay
                };
            });
            this.tableData = mergeAndDistinctByProperty(this.tableData, selectedData, 'detailConfigurationName');
        },
        handleDelete (rIndex) {
            this.$confirm('是否删除此项配置明细?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.tableData.splice(rIndex, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
            }).catch(() => { });
        },
        handleCancel () {
            this.$confirm('确认取消后，系统不保存当前数据，请二次确认！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$nextTick(() => {
                    // 调用全局挂载的方法，关闭当前页面
                    this.$store.dispatch('delView', this.$route).then(() => {
                        this.$router.replace({ path: '/otp/transport-center/driver-payment-duration-config' });
                    }).catch(() => { });
                });
            }).catch(() => { });
        },
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) return;
                const isValidatedTableData = validatedTableData(this.tableData);
                if (!isValidatedTableData) return;
                this.submitLoading = true;
                const params = {
                    ...this.formData,
                    list: this.tableData
                };
                const isValidateData = await this.validateSubmitParams(params);
                if (!isValidateData) return;
                confirmSubmission(params).then(res => {
                    if (res && +res.code === 0 && res.data) {
                        this.$nextTick(() => {
                            // 调用全局挂载的方法，关闭当前页面,并跳转其他页面
                            this.$store.dispatch('delView', this.$route).then(() => {
                                this.$router.replace({
                                    path: '/otp/transport-center/payment-duration-mip',
                                    query: {
                                        requestId: res.data
                                    }
                                });
                            }).catch(() => { });
                        });
                    }
                }).catch(() => {
                }).finally(() => {
                    this.submitLoading = false;
                });
            });
        },
        validateSubmitParams (data) {
            return checkInfo(data).then(res => {
                if (res && +res.code === 0) {
                    return res.data || false;
                }
            }).catch(() => {
                return false;
            }).finally(() => {
                this.submitLoading = false;
            });
        },
        destroyed () {
            window.removeEventListener('resize', this.initTableHeight);
        }
    }
};
</script>

<style lang="less">
.payment-duration-detail {
    .el-card__body {
        display: flex;
        justify-content: space-between;
        .remark-title {
            font-size: 14px;
            font-weight: 600;
        }
        .remark {
            padding: 4px 0px;
            font-size: 12px;
            color: #999999;
        }
    }
    .content-wrapper {
        padding: 10px 18px;
        .title {
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: 600;
        }
        .tooltip {
            font-size: 12px;
            color: red;
        }
        .el-form-item__label {
            line-height: 26px;
        }
        .el-form-item__content {
            line-height: 26px;
        }
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-select {
            width: 100%;
        }
        .table-wrapper {
            margin-left: 110px;
            margin-right: 110px;
            .el-table--border {
                border-right: 1px solid #ebeef5;
                border-bottom: 1px solid #ebeef5;
            }
            .el-table td {
                padding: 2px 0;
            }
        }
    }
}
</style>
